import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import { TdActions } from '@/components/tdActions'
import Icon from '@/components/Icon'

export function previewHelpContentActionsCell (props) {
  class PreviewHelpContentActionsCell extends GridCell {
    handleClick = () => {
      props.onPreview(this.props.dataItem)
    }
    render () {
      return (
        <TdActions>
          <button
            className='btn-icon'
            title={props.localize('Common.Preview')}
            onClick={this.handleClick}>
            <Icon name='show' />
          </button>
        </TdActions>
      )
    }
  }

  return {
    field: 'key',
    title: props.title || ' ',
    sortable: false,
    filterable: false,
    width: 55,
    cell: PreviewHelpContentActionsCell
  }
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/helpPages/actionButtonCell.js